import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateEquipmentVariable, EquipmentVariable, EquipmentVariableListResponse, UpdateEquipmentVariable } from '@frontend/equipment-variable/types';

export class EquipmentVariableClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchEquipmentVariables(
        accountId: string,
        equipmentId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<EquipmentVariableListResponse> {
        return await this.apiPaginated<EquipmentVariableListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/variables`,
            queryParams
        );
    }

    public static async postEquipmentVariable(accountId: string, equipmentId: string, variable: CreateEquipmentVariable): Promise<EquipmentVariable> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/variables`, variable);
        return await this.handleResponse<EquipmentVariable>(response);
    }

    public static async fetchEquipmentVariable(accountId: string, equipmentId: string, variableId: string): Promise<EquipmentVariable> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/variables/${variableId}`);
        return await this.handleResponse<EquipmentVariable>(response);
    }

    public static async patchEquipmentVariable(
        accountId: string,
        equipmentId: string,
        variableId: string,
        variable: UpdateEquipmentVariable
    ): Promise<EquipmentVariable> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/variables/${variableId}`, variable);
        return await this.handleResponse<EquipmentVariable>(response);
    }

    public static async deleteEquipmentVariable(accountId: string, equipmentId: string, variableId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/variables/${variableId}`);
        return await this.handleVoidResponse(response);
    }
}
